/**
 * Die acht Fahrzeugstatus in der Reihenfolge der Spalten der Übersicht. Die
 * Übersicht baut daraus ihre Spalten, der Bearbeiten-Dialog sein Dropdown —
 * beide sollen dieselben Bezeichnungen zeigen.
 */
export const STATUS = [
  {
    bg: "#7fc865",
    color: "",
    column: "einsatzbereit",
    title: "Regelbedarf",
  },
  {
    bg: "#f8e43a",
    color: "",
    column: "taktischeReserve",
    title: "Spitzenbedarf",
  },
  {
    bg: "#e89042",
    color: "",
    column: "technischeReserve",
    title: "Reservefahrzeuge",
  },
  {
    bg: "#112e4b",
    color: "white",
    column: "sonderbedarf",
    title: "Sonderbedarf",
  },
  {
    bg: "#1b5084",
    color: "white",
    column: "fuehrung",
    title: "Führung",
  },
  {
    bg: "#d72020",
    color: "white",
    column: "ausserdienst",
    title: "Nicht Dienstfähig",
  },
  {
    bg: "#c93636",
    color: "white",
    column: "fahrauftrag",
    title: "Fahrauftrag",
  },
  {
    bg: "#2987e7",
    color: "white",
    column: "desinfektion",
    title: "Desinfektion",
  },
];

/** Anzeigename eines Status; Unbekanntes bleibt, wie es ist. */
export const statusText = (status) =>
  STATUS.find((eintrag) => eintrag.column === status)?.title ?? status;

/**
 * In diesen Spalten fährt ein Fahrzeug unter Funkkennung von einem Dienstort
 * aus; in allen anderen wird die Funkkennung beim Speichern frei.
 */
const IM_DIENST = [
  "einsatzbereit",
  "taktischeReserve",
  "sonderbedarf",
  "fuehrung",
  "fahrauftrag",
];

export const brauchtFunkkennungUndDienstort = (status) =>
  IM_DIENST.includes(status);
